import Chip from '@components/v2/ui/Chip/Chip';
import { Box, Stack } from '@mui/material';
import { VIZ_EXPANDED } from '../viz.styles';
import { VizRange } from '../viz.types';
import VizRangeStepper from './VizRangeStepper';

interface VizRangeSelectorProps {
  ranges: VizRange[];
  selectedIndex: number;
  onSelect: (index: number) => void;
}

const LABEL_PADDING_X = 1.75;
const CHIP_HEIGHT = 28;

const VizRangeSelector = ({ ranges, selectedIndex, onSelect }: VizRangeSelectorProps) => (
  <>
    <Box sx={{ [VIZ_EXPANDED]: { display: 'none' } }}>
      <VizRangeStepper ranges={ranges} selectedIndex={selectedIndex} onSelect={onSelect} />
    </Box>
    <Stack
      direction="row"
      sx={{ gap: 1, flexWrap: 'wrap', display: 'none', [VIZ_EXPANDED]: { display: 'flex' } }}
    >
      {ranges.map((range, index) => (
        <Chip
          key={index}
          label={range.label}
          size="medium"
          color={index === selectedIndex ? 'default' : 'secondary'}
          sx={(theme) => ({
            height: CHIP_HEIGHT,
            borderRadius: `${theme.shape.borderRadiusFull}px`,
            '& .MuiChip-label': {
              paddingInline: LABEL_PADDING_X,
              fontSize: theme.typography.micro1.fontSize,
            },
          })}
          onClick={() => onSelect(index)}
        />
      ))}
    </Stack>
  </>
);

export default VizRangeSelector;
